module.exports = __webpack_public_path__ + "static/media/66088766_1333038250178912_573418803061325824_o.e6e033f3.jpg";